'use-client';
import * as React from 'react';
import type { IResponsivePopupPageProps } from '../../../ResponsivePopupPage.types';
import ResponsivePopupPage from '../../ResponsivePopupPage';

const WithoutOverlay: React.FC<IResponsivePopupPageProps> = props => {
  return (
    <ResponsivePopupPage
      {...props}
      // FYI: This is temporary hack to make overlay work in PopupContainer (WithOverlay skin). In the future, PopupContainer will have own style properties so we will remove this.
      overlayCssVars={
        {
          '--page-bg': 'var(--bg)',
          '--page-alpha-bg': 'var(--alpha-bg)',
        } as React.CSSProperties
      }
      withOverlay={false}
    />
  );
};

export default WithoutOverlay;
